module.exports = __webpack_public_path__ + "img/icon_plus.8cbe3d03.svg";